module.exports = "/_next/static/images/LoganBerlin-9fa455f3f9002d2765dccd303689a394.webp";